<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="terms-of-service">
      <Title jpn="이용 약관" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">주식회사 제로 플레이스(이하 “당사”라고 합니다.)가 제공하는 본 사이트에서 제공하는 서비스(이하 “본건 서비스”라고 합니다.)에 관한 조건 및 당사와 서비스 이용자와의 권리 의무 관계에 대해서, 이하와 같이 사이트 이용 규약(그 외의 당사가 계약의 내용으로서 따로 정하는 것을 포함합니다.이하 “본건 규약”이라고 합니다.)로 정합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제1조(용어의 정의)</span>
            <span class="text">본건 규약에 있어서 이하의 각 호의 용어의 의미는, 해당 각 호에 정하는대로로 합니다.</span>
            <span class="text">(1) 「당사」란, 본 서비스를 제공하는 주식회사 제로 플레이스를 말합니다.</span>
            <span class="text">(2) 「본 사이트」란, 당사가 제공하는 사이트
              <a href="https://dorima-gtchax.com/" target="_blank">https://dorima-gtchax.com/</a>
              를 말합니다.</span>
            <span class="text">(3) 「본 규약」이란, 서비스 이용자가 준수해야 할 규정을 말합니다.</span>
            <span class="text">(4) 「서비스 이용 계약」이란, 본건 서비스의 이용에 관한 계약을 말합니다.</span>
            <span class="text">(5) 「서비스 이용자」란, 당사와 서비스 이용 계약을 체결한 사람을 말합니다.</span>
            <span class="text">(6) 「계정」이란, 서비스 이용자가 본건 서비스에 등록한 서비스 이용자에 관한 정보를 말합니다.</span>
            <span class="text">(7) 「비밀번호」란 고객이 직접 작성한 영숫자 조합으로 구성된 암호를 말합니다.</span>
            <span class="text">(8) 「메일 주소」란, 서비스 이용자가 본 서비스에 등록해 주신 메일 주소를 말합니다.</span>
            <span class="text">(9) 「Coin」이란, 본 사이트내에서 사용할 수 있는 가상 통화를 말합니다.</span>
            <span class="text">(10) 「상품」이란, 본 사이트내의 게임에서 획득할 수 있는 카드를 나타냅니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제2조(적용 범위)</span>
            <span class="text">1 서비스 이용자는 본 약관의 규정에 따라 본 사이트를 사용하여야 하며, 본 약관에 동의하지 않는 한 본 사이트를 이용할 수 없습니다.</span>
            <span class="text">2 서비스 이용자가, 본 사이트의 등록 화면에 있어서, 본 약관에의 동의 수속을 실시한 시점에서, 서비스 이용자와 당사와의 사이, 본 약관의 제규정에 따른 이용 계약(이하 「본 이용 계약」이라고 합니다.)이 성립해, 본 약관의 내용이 서비스 이용자와 당사와의 계약 내용이 됩니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제3조(본건 서비스의 내용 등)</span>
            <span class="text">1 본건 서비스의 내용·이용 순서는, 이용 가이드에 기재된 대로입니다.</span>
            <span class="text">2 당사는, 스스로의 판단에 의해, 수시로 본건 서비스의 내용을 변경 또는 제공을 종료할 수 있습니다.</span>
            <span class="text">3 서비스 이용자는, 당사에 의한 본건 서비스의 내용의 변경 또는 제공의 종료에 대해 이의를 제기하거나, 손해 배상 그 외의 청구를 실시할 수 없습니다.</span>
            <span class="text">4 본건 서비스의 제공을 종료하는 경우, 당사가 정하는 방법에 의해 이용 계약자에게 사전에 통지하는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제4조(이용 신청)</span>
            <span class="text">1 본건 서비스의 이용을 희망하는 경우는, 본 사이트에 액세스해, 본건 규약에 동의 후, 본건 서비스의 이용 신청(이하, 본조에 있어서 「서비스 이용 신청」이라고 합니다.)을 실시하는 것으로 합니다.</span>
            <span class="text">2 서비스 이용 신청에 대해, 당사가 승낙하는 것으로, 당사와 서비스 이용 신청을 실시한 (이하, 본조에 있어서 「서비스 이용 신청자」라고 합니다.)와의 사이에, 본건 규약에 근거하는 서비스 이용 계약이 체결됩니다.</span>
            <span class="text">3 본 사이트의 이용 희망자가 미성년자등인 경우, 본 사이트의 이용시에, 사전에 친권자등의 법정 대리인의 동의를 얻는 것으로 합니다. 미성년자등이 본 규약에 동의한 경우는, 법정 대리인의 동의를 얻은 것으로 간주해, 일체의 책임은 지지 않습니다.</span>
            <span class="text">4 당사는 서비스 이용 신청을 승낙하지 않는 경우가 있습니다. 이 경우 당사는 그 이유를 공개할 의무가 없습니다.</span>
            <span class="text">5 서비스 이용 신청자는 서비스 이용 신청 시 부정확한 정보 또는 허위 정보를 전송해서는 안 됩니다.</span>
            <span class="text">6 계정정보의 오류나 변경의 지연 및 기타 결함으로 인해 본건 서비스의 이용에 지장이 발생한 경우에도 당사는 해당 지장에 대해 책임을 지지 않습니다.</span>
            <span class="text">7 본 약관 및 Coin 이용 약관은 당사가 기획 개발하여 운영 제공하는
              <a href="https://dorima-gtchax.com/" target="_blank">https://dorima-gtchax.com/</a>
              에서 유료 서비스를 이용하기 위하여 당사와 서비스 이용자 간의 약정을 정하는 것입니다.</span>
            <span class="text">8 유료 서비스를 이용하는 모든 사용자는 본 약관의 약정을 준수하는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제5조(서비스 이용자에 의한 서비스 이용 계약의 해지)</span>
            <span class="text">서비스 이용자는, 본건 서비스상에서의 해약 수속 그 외의 당사가 별도 지정하는 해약 수속을 실시하는 것으로, 언제라도 서비스 이용 계약을 해약할 수 있습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제6조(본건 서비스 이용 등록)</span>
            <span class="text">1 서비스 이용자가 본건 서비스를 이용하기 위해 필요한 단말, 통신 기기, 소프트웨어, 인터넷에의 접속에 관한 계약 등의 준비는, 서비스 이용자가 자기의 비용과 책임에 있어서 준비해야 합니다.</span>
            <span class="text">2 당사는, 서비스 이용자에 의한 본건 서비스의 이용 환경에 대해서 일절 관여하지 않고, 또 일절의 책임을 지지 않습니다.</span>
            <span class="text">3 서비스 이용자는, 등록시에 자신의 메일 주소를 등록하는 것으로, 이것을 본건 서비스에 있어서의 메일 주소로서 이용할 수 있습니다. 덧붙여 사이트내에서 메일 주소의 변경은 할 수 없기 때문에 잘못된 메일 주소로 등록을 했을 경우나 메일 주소의 변경이 있을 때는, 본인 확인을 해 주신 다음에 당사에 있어서 변경을 행하겠습니다.</span>
            <span class="text">4 서비스 이용자는, 원칙적으로 1인 1계정으로 하고, 복수계정의 소지를 금지합니다. 덧붙여 당사는 서비스 이용자의 복수 계정의 소지가 발각되었을 경우, 사전의 고지 없이 해당 서비스 이용자의 소지하는 계정을 삭제합니다. 이때 삭제한 계정에 과금된 Coin은 모두 해지됩니다.</span>
            <span class="text">5 본 사이트의 운영이 곤란하다고 당사가 판단한 경우, 해당 요인이 해소될 때까지, 당사는 서비스 이용자에게, 본 서비스의 이용을 제한할 수 있는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제7조(계정 관리)</span>
            <span class="text">1 이용자는, 이용시에 등록한 정보(이하, 「등록 정보」라고 합니다. 메일 주소나 ID·패스워드등을 포함합니다)에 대해서, 자기의 책임하에 등록, 관리하는 것으로 합니다. 이용자는 이를 제3자에게 이용시키거나 대여, 양도, 명의변경, 매매 등을 해서는 안 됩니다.</span>
            <span class="text">2 당사는, 등록 정보에 의해 본 서비스의 이용이 있었을 경우, 이용 등록을 행한 본인이 이용한 것과 취급할 수 있고, 해당 이용에 의해 생긴 결과 및 그에 따른 일체의 책임에 대해서는, 이용 등록을 실시한 본인에 귀속하는 것으로 합니다.</span>
            <span class="text">3 이용자는 등록정보의 부정사용에 의해 당사 또는 제3자에게 손해가 발생한 경우 당사 및 제3자에 대하여 해당 손해를 배상하는 것으로 합니다.</span>
            <span class="text">4 등록 정보의 관리는, 이용자가 자기의 책임하에서 실시하는 것으로 하고, 등록 정보가 부정확 또는 허위였기 때문에 이용자가 입은 일체의 불이익 및 손해에 관하여, 당사는 책임을 지지 않습니다.</span>
            <span class="text">5 등록 정보가 도용되거나 제삼자에게 이용되고 있는 것이 판명된 경우, 이용자는 즉시 그 취지를 당사에 통지함과 동시에 당사로부터의 지시에 따릅니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제8조(서비스 이용자의 의무)</span>
            <span class="text">1 서비스 이용자는, 당사가 별도 명시적으로 허가한 경우를 제외하고, 본건 서비스에 관하여, 이하의 각 호의 행위를 실시해서는 안됩니다.</span>
            <span class="text">(1) 법령을 위반하는 행위</span>
            <span class="text">(2) 본건 규약을 위반하는 행위</span>
            <span class="text">(3) 당사 또는 제3자에게 부당하게 불이익 또는 손해를 일으키는 행위</span>
            <span class="text">(4) 본건 서비스의 각 기능의 목적외 이용</span>
            <span class="text">(5) 본건 서비스를 통상 이용할 때에 사용되는 방법과는 다른 방법(자동화, 스크래핑을 포함합니다.)에 의한 본건 서비스의 이용</span>
            <span class="text">(6) 당사 또는 제 3 자의 지적 재산권 침해</span>
            <span class="text">(7) 당사 또는 제3자에 관한 프라이버시 또는 초상권의 침해</span>
            <span class="text">(8) 당사 또는 제 3 자의 비밀 정보의 유출</span>
            <span class="text">(9) 본건 서비스 내에서 열람할 수 있는 정보의 제3자 제공</span>
            <span class="text">(10) 본인의 동의를 얻지 않는 제3자의 개인정보의 제공</span>
            <span class="text">(11) 당사 또는 제3자에 대한 비방 중상</span>
            <span class="text">(12) 당사 또는 제3자의 명예 또는 신용의 훼손</span>
            <span class="text">(13) 당사 또는 제3자로의 스푸핑</span>
            <span class="text">(14) 제3자의 계정 정보의 이용</span>
            <span class="text">(15)이 서비스를 제공하는 데 사용되는 시스템에 기록 된 정보의 변조 또는 삭제</span>
            <span class="text">(16) 유해한 컴퓨터 프로그램 등의 송신 또는 당사 또는 제3자의 요구에 따라 송신 가능한 상태로 하는 것</span>
            <span class="text">(17) 기타 서비스 및 상품 등 및 단체 및 조직 등의 광고, 홍보 또는 권유</span>
            <span class="text">(18) 본건 서비스의 제공 그 외의 업무의 방해</span>
            <span class="text">(19) 컴퓨터 바이러스 및 기타 유해한 컴퓨터 프로그램을 포함한 정보 전송</span>
            <span class="text">(20) 본건 서비스의 제공에 이용되고 있는 전기 통신 설비(서버를 포함합니다만 이것에 한정되지 않습니다.이하, 「전기 통신 설비」라고 합니다.)에 과도한 부하를 가하는 행위</span>
            <span class="text">(21) 본건 서비스의 제공에 사용되는 시스템에 설정된 액세스 제어 기능의 해제 또는 회피 그 외의 무단 액세스</span>
            <span class="text">(22) 본 서비스에 사용되는 소프트웨어의 복제, 수정, 전재, 변경, 변경, 리버스 엔지니어링, 디스어셈블, 디컴파일, 번역 또는 해석</span>
            <span class="text">(23) 사기적 수단(이른바 피싱 및 이와 유사한 수단을 포함합니다.)에 의한 당사 또는 제3자로부터의 정보의 취득</span>
            <span class="text">(24) 당사에 대한 과도하게 장시간의 가전, 유사한 문의의 과도한 반복, 또는 의무나 이유 없는 대응의 강요</span>
            <span class="text">(25) 기기의 판매, 정보의 제공, 하이퍼 링크의 설정 등에 의해 상기 각 호의 어느 하나에 해당하는 행위를 조장하는 행위</span>
            <span class="text">(26) 상기 각 호의 어느 하나에 해당할 우려가 있는 행위</span>
            <span class="text">(27) 그 외 당사가 부적당(등록 명의인명이 부적절, 계정의 중복, 문의시의 발언 내용 등)이라고 판단한 행위</span>
            <span class="text">2 계정 정보에 변경이 발생한 경우, 서비스 이용자는 지체 없이 해당 변경 후의 정보를 등록해야 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제9조(개인정보의 취급)</span>
            <span class="text">서비스 이용자는 당사가 개인정보보호정책의 규정에 따라 서비스 이용자의 개인정보를 취급하는 것에 동의합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제10조(서비스 이용자에게 걸리는 정보의 삭제)</span>
            <span class="text">1 당사는, 서비스 이용자와의 서비스 이용 계약이 해지된 경우, 해당 서비스 이용자에게 걸리는 정보(계정 정보, 인앱 통화 및 유상 서비스에 관한 정보를 포함합니다만, 이것에 한정되지 않습니다.)를 삭제합니다.</span>
            <span class="text">2 당사는 전항에 따라 삭제한 서비스 이용자에게 걸리는 정보의 복원 등은 실시하지 않습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제11조(서비스에 관한 권리)</span>
            <span class="text">당사로부터, 본건 서비스를 통해서 서비스 이용자에게 제공되는 컨텐츠 및 정보 등에 관한 지적재산권 그 외의 권리는, 당사 또는 당사에 권리를 허락하고 있는 제3자에 귀속합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제12조(유료 서비스에 대해서)</span>
            <span class="text">1 서비스 이용자는, 당사 소정의 방법에 의해, 당사가 본건 서비스내 또는 당사가 제공하는 다른 서비스로 제시하고 있는 금액으로 당사가 제공하는 서비스내에서만 사용 가능한 Coin를 구입할 수 있습니다. 또한 당사는 서비스 이용자에게 Coin의 구매에 대해 구매 단위, 결제 방법, 이용 기간 및 기타 구매 조건을 마련할 수 있으며, 설정한 구매 조건 및 지불 가능 금액 등은 본건 서비스 내에 게재합니다.</span>
            <span class="text">2 Coin의 이용 조건 그 외 Coin의 이용에 관련된 조건에 대해서는, 본 약관 외, 본 사이트내에 게재하는 Coin 이용 약관의 규정에 따르는 것으로 합니다.</span>
            <span class="text">3 서비스 이용자는, 유료 서비스 이용료(그 외 유료 서비스를 통해서 서비스 이용자에게 채무가 생겼을 경우는 그것도 포함한다)를, 당사가 별도로 정하는 지불 방법과 조건에 따라, 지불하는 것으로 합니다. 당사는 당사에 과실이 있는 등의 법적 책임이 있는 경우를 제외하고, 한 번 지불을 받은 해당 요금에 대해 일절 환불하지 않습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제13조(상품에 대해서)</span>
            <span class="text">1 서비스 이용자는 유료 서비스를 이용하여 획득한 상품의 배송을 받을 수 있습니다.</span>
            <span class="text">2 서비스 이용자는, 획득한 상품을, 획득시보다 24시간 이내까지 보유할 수 있어(이하, 해당 기간을 「보유 기간」이라고 합니다.) 배송을 희망하는 경우에는, 본 사이트로부터 소정의 배송 수속을 행해야 합니다.</span>
            <span class="text">3 전항의 보유 기간을 지났을 경우, 서비스 이용자는 그러한 상품의 배송을 받을 권리를 잃는 것으로 합니다. 덧붙여 보유 기간을 지난 상품에 대해서는 자동으로 Coin에 반환하는 것으로 합니다.</span>
            <span class="text">4 당사는, 서비스 이용자가 획득한 상품에 대해서, 배송하는 것이 당사의 책임으로 돌려야 할 사유에 의해 불능인 것이 분명해진 경우에는, 당사는, 서비스 이용자가 해당 상품을 취득하기 위해서 사용한 Coin을 서비스 이용자에게 부여하는 것으로, 그 손해 배상 책임을 면하는 것으로 합니다. 또한 당사는 해당 상품과 동일한 상품을 취득하여 교부할 의무를 지지 않습니다.</span>
            <span class="text">5 상품에 관한 배송료는 전액 당사 부담으로 하겠습니다. 덧붙여 국외에의 배송에 대해서는 별도 요금을 징수하는 경우가 있습니다.</span>
            <span class="text">6 배송 방법은 당사 제휴처의 야마토 운수 주식회사 또는 당사 지정 운송업자를 이용합니다.</span>
            <span class="text">7 배송시기는, 매월 5일·10일·15일·20일·25일·말일에, 상기 당사 지정 운송 회사에 인도를 행합니다.</span>
            <span class="text">※상기 배송 시기 전후의 이용의 경우는, 최근의 배송 시기가 아니고, 다음 배송 시기 이후가 되는 일이 있습니다.</span>
            <span class="text">※발송 준비 완료하는 대로, 발송 통지를 합니다. 따라서 추적 번호가 인터넷에 반영되는 것이 다음날 이후가 될 수 있습니다. 미리 용서해주십시오.</span>
            <span class="text">8 상품 발송중의 파손등의 트러블이 발생했을 경우, 당사는 일절의 책임을 지지 않습니다.</span>
            <span class="text">9 당사는, 해당 상품의 배송까지 서비스 이용자의 규약 위반 행위등이 인정된 경우에는, 상품의 배송을 정지할 수 있는 것으로 합니다. 또한, 이로 인한 손해에 대해 당사는 배상할 책임을 지지 않습니다.</span>
            <span class="text">10 당사가 서비스 이용자에게 상품을 배송한 후, 수령 거부, 목적지 불명 등으로 반송되어 해당 서비스 이용자가 재송 절차를 하지 않은 경우에는 해당 서비스 이용자는 해당 상품에 관한 권리의 일체를 잃는 것으로 합니다. 덧붙여 이 경우라도, 당사는 Coin의 반환 의무등의 일체의 보상, 손해 배상 의무를 지지 않습니다.</span>
            <span class="text">11.배송일 등의 문의에는 대응 하기 어렵습니다, 미리 용서해 주십시오.</span>
            <span class="text">12. 본 시스템은 상품명과 환원 코인이 연결되어 있습니다. 만일, 화상이 상품명과 일치하지 않는 경우는, 화상의 상품의 발송 혹은 환원 Coin가 아니고, 그 상품명과 환원 Coin을 우선하겠습니다. 미리 용서해 주십시오.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제14조(신용카드 등에 의한 이용)</span>
            <span class="text">1 본 사이트에 있어서, 서비스 이용자는, 신용카드에 의한 결제 또는 당사가 제공하는 다른 서비스내에 있어서는 해당 서비스내에서 정해진 방법을 이용하는 것으로, Coin의 구입을 행할 수 있습니다. 다만, 결제에 이용하는 신용카드는, 서비스 이용자 본인 명의의 것이며, 또한, 결제시에 유효한 것에 한정됩니다.</span>
            <span class="text">2 서비스 이용자는, 신용 카드 결제를 이용하는 경우, 해당 서비스 이용자 본인 명의의 신용 카드에 관한 정보(신용 카드의 종류, 카드 번호 및 유효 기한 등을 말하는 것으로, 이하, 총칭하여 「신용 카드 정보」라고 합니다.)를 당사 지정의 방법에 의해 등록하는 것으로 합니다.</span>
            <span class="text">3 신용 카드 정보의 오등록 등에 의해 서비스 이용자에게 발생한 손해에 대해서, 당사는 일절 책임을 지지 않습니다. 또한, 신용카드의 이용에 관한 서비스 이용자의 허위 또는 부정에 의해 당사가 손해를 입은 경우, 해당 서비스 이용자는 당사에 대하여 당사가 입은 일체의 손해를 배상하는 것으로 합니다.</span>
            <span class="text">4 당사는, 본 사이트의 이용을 위해서 발생한 요금에 대한 신용카드에 의한 결제시에 있어서, 소정의 방법에 의해 서비스 이용자가 결제에 이용하는 신용카드에 대해서, 신용카드 회사에 지불 가부의 승인을 요구하는 것으로 하고, 그 승인을 얻을 수 없는 경우는, 결제를 하지 않는 것으로 할 수 있습니다. 이 경우, 서비스 이용자에게 손해가 발생했을 때라도, 당사는 해당 손해에 대해 일절 책임을 지지 않습니다.</span>
            <span class="text">5 서비스 이용자의 신용카드에 의한 결제가 종료한 후에도, 신용카드 회사로부터 당사에 대하여, 해당 신용카드의 이용에 대해 거절 또는 정지의 통지가 이루어진 경우 또는 신용카드의 이용에 관한 해당 서비스 이용자의 허위 혹은 부정이 판명된 경우, 당사는 그 이유의 여하를 불문하고, 해당 서비스 이용자에 의한 모든 결제를 중지할 수 있는 것.</span>
            <span class="text">6 서비스 이용자는, 당사가 제공하는 다른 서비스 내에서 본 서비스에 이용할 수 있는 Coin을 구입할 수 있습니다만, 그 경우에는, 본 서비스와 동일한 어카운트에 의해 구입을 해야 하고, 다른 어카운트에 의해 Coin를 구입한 경우에는, 본 서비스내에서 Coin이 반영되지 않고, 사용할 수 없는 것을 양해하는 것으로 합니다. 덧붙여 그 경우에는, 당사는 일절의 환불등을 실시하지 않고, 일절의 책임을 지지 않는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제15조(결제기관과의 관계 등)</span>
            <span class="text">1 서비스 이용자와 본 서비스를 위해 당사가 이용하는 과금 결제 회사 또는 결제 대행 회사와의 사이에서 본 서비스의 요금 그 외의 금전 채무를 둘러싸고 분쟁이 생겼을 경우, 해당 서비스 이용자와 해당 회사와의 사이에서 해결하는 것으로 하고, 당사는, 일절 거기에 관여하지 않고, 일절의 책임을 지지 않는 것으로 합니다.</span>
            <span class="text">2 전항의 분쟁이 서비스 이용자의 책임에 돌려야 할 사유에 의해 발생한 것으로, 이에 의해 당사가 손해를 입은 경우, 해당 서비스 이용자는 당사에 대하여 당사가 입은 일체의 손해를 배상하는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제16조(본건 서비스의 제공의 정지 등)</span>
            <span class="text">당사는 다음의 경우에 손해배상이나 기타 의무를 지지 않고 일시적으로 본건 서비스의 전부 또는 일부의 제공을 정지할 수 있는 것으로 합니다.</span>
            <span class="text">(1) 본건 서비스를 제공하기 위한 설비의 보수 또는 점검 등을 실시하는 경우</span>
            <span class="text">(2) 화재, 정전 등에 의해 본건 서비스의 제공에 지장이 생긴 경우</span>
            <span class="text">(3) 지진, 분화, 홍수, 쓰나미 등의 천재 재해에 의해 본건 서비스의 제공에 지장이 생긴 경우</span>
            <span class="text">(4) 전쟁, 동란, 폭동, 소란, 노동 쟁의, 감염증의 만연, 긴급 사태 선언의 발출 등에 의해 본건 서비스의 제공에 지장이 생긴 경우</span>
            <span class="text">(5) 본건 서비스의 운용상 또는 기술상의 이유로 당사가 본건 서비스의 제공을 일시적으로 연기 또는 중단할 필요가 있다고 판단한 경우</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제17조(이용 제한 등)</span>
            <span class="text">1 당사는, 서비스 이용자가 이하의 각 호의 어느 하나에 해당한다고 판단한 경우에는, 서비스 이용자에게 사전에 통지하지 않고, 본건 서비스의 이용의 정지, 또는 서비스 이용 계약의 해약 등의 조치(이하, 본조에 있어서 「이용 제한 조치」라고 합니다.)를 강구할 수 있는 것으로 합니다.</span>
            <span class="text">(1) 서비스 이용자의 패스워드가 누설하는 것에 의해, 제삼자가 본 서비스를 부정 이용한 경우, 당사의 다른 서비스를 제삼자가 부정하게 이용했을 경우 또는 이러한 우려가 있는 경우.</span>
            <span class="text">(2) 서비스 이용자의 행위에 의해 당사의 사업에 지장을 초래한다고 판단한 경우.</span>
            <span class="text">(3) 계정을 복수 취득한(금지행위) 경우.</span>
            <span class="text">(4) 본건 규약을 위반하거나 그 우려가 있는 경우.</span>
            <span class="text">(5) 전 각호 외, 이용 제한 조치를 강구할 필요가 있다고 당사가 판단한 경우.</span>
            <span class="text">2 당사가 제1항에 근거해 이용 제한 조치를 강구한 것에 의해, 서비스 이용자에게 손해가 발생한 경우라도, 당사는 해당 손해에 대해서 일절 책임을 지지 않습니다.</span>
            <span class="text">3 본조에 의거 서비스 이용 계약이 해약되는 경우, 서비스 이용자는 당사에 부담하고 있는 채무에 대해 기한의 이익을 상실해, 즉시 당사에 대해서 모든 채무를 이행해야 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제18조(면책)</span>
            <span class="text">1 본건 규약에 특별한 규정이 없는 한, 당사는, 서비스 이용자에게 발생한 손해를 배상하지 않고, 서비스 이용자는 당사에 해당 손해에 대한 청구는 할 수 없습니다. 또, 서비스 이용자는, 본건 서비스의 이용이나 이용의 종료 등에 의해 제삼자에 대해 손해를 끼쳤을 경우, 자기의 책임으로 이것을 해결해, 당사는 책임을 부담하지 않습니다. 다만, 당해 손해가 당사의 고의 또는 중과실에 의해 발생한 경우에는 그러하지 아니합니다.</span>
            <span class="text">2 당사는 천재지변, 전쟁, 폭동, 내란, 연소에 의한 화재, 홍수, 법령 개폐 제정, 정전, 공권력 개입, 파업 및 기타 노동쟁의, 수송기관 사고, 감염증의 만연 연, 긴급 사태 선언의 발령 그 외 당사의 책임으로 돌아가지 않는 사유로부터 생긴 서비스 이용 계약상의 의무의 불이행에 대해서, 손해 배상 책임 그 외 일체의 책임을 지지 않습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제19조(서비스 이용자에게 통지)</span>
            <span class="text">서비스 이용자는, 당사로부터 서비스 이용자에게의 통지가 이하의 어느 쪽인가의 방법으로 행해지는 것에 동의합니다.</span>
            <span class="text">(1) 본건 서비스내에 게재해 실시합니다. 이 경우, 게재된 때에 서비스 이용자에 대한 통지가 완료된 것으로 간주합니다.</span>
            <span class="text">(2) 당사의 Web 사이트상에 게재해 실시합니다. 이 경우, 게재된 때에 서비스 이용자에 대한 통지가 완료된 것으로 간주합니다.</span>
            <span class="text">(3) 서비스 이용자가 이용 신청 시 또는 그 후에 당사에 신고한 서비스 이용자의 전자 메일 주소로 전자 메일을 송신하여 실시합니다. 이 경우 서비스 이용자의 전자 메일 주소로 전자 메일을 보낼 때 서비스 이용자에 대한 통지가 완료된 것으로 간주합니다.</span>
            <span class="text">(4) 그 외, 당사가 적절하다고 판단하는 방법으로 실시합니다. 이 경우 해당 통지 중 당사가 지정한 때에 서비스 이용자에 대한 통지가 완료된 것으로 간주합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제20조(반사회적 세력의 배제)</span>
            <span class="text">서비스 이용자는, 다음의 각 호에 대해 표명해, 보증합니다.</span>
            <span class="text">(1) 과거 또는 장래에 있어서, 스스로가 반사회적 세력(폭력단, 폭력단원, 폭력단준 구성원, 폭력단 관계기업, 총회가게, 사회운동 등 표보 골로, 정치 활동 표보 골로 또는 특수 지능 폭력 집단 등을 포함한다. 이하 동일 )이 아닌 것, 반사회적 세력과 거래를 하지 않은 것, 자금 제공 등의 행위를 통해 반사회적 세력의 유지, 운영에 협력 또는 관여하지 않는 것, 그 외 반사회적 세력과의 의도적인 교류가 없는 것</span>
            <span class="text">(2) 스스로 또는 제3자를 이용하여 당사 또는 당사의 종업원에 대하여 폭행·상해·협박·공갈·위압 등의 폭력적 또는 협박적 행위 또는 풍설의 유포나 위계 등의 사기적 수법을 이용한 요구, 합리적인 범위를 넘는 부당한 요구, 업무의 방해, 명예·</span>
            <span class="text">(3) 스스로가, 반사회적 세력인 것, 또는 반사회적 세력과 관계가 있는 것을, 당사 또는 제삼자에게 전하는 등의 행위를 하지 않는 것</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제21조(서비스 이용 계약상의 지위의 이전 등)</span>
            <span class="text">1 서비스 이용자는, 서비스 이용 계약상의 지위 또는 서비스 이용 계약에 관하여 가지는 권리 혹은 의무에 대해서, 제삼자에게 양도, 승계, 매매, 명의 변경, 담보 설정등을 할 수 없습니다.</span>
            <span class="text">2 사업 양도, 회사 분할, 합병 등의 방법을 불문하고, 당사가 제3자에 대하여 본건 서비스에 걸리는 사업의 양도 또는 승계(이하 「사업 양도 등」이라고 합니다.)를 하는 경우에는, 당사는 해당 사업 양도 등에 따라, 서비스 이용계 약상의 지위, 서비스 이용 계약에 근거하는 권리 및 의무 및 계정 정보를 취급할 권한을 서비스 이용자의 별도 동의를 얻지 않고 해당 사업 양도 등의 양수인에게 양도 또는 승계할 수 있는 것으로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제22조(의무의 존속)</span>
            <span class="text">서비스 이용 계약이 종료된 경우에도 서비스 이용자는 서비스 이용 계약의 종료 전에 발생한 의무를 면할 수 없습니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제23조(본건건 규약의 변경)</span>
            <span class="text">1 당사는, 이하의 각 호의 경우에는, 서비스 이용자의 사전의 승낙을 얻지 않고, 본건 규약을 변경할 수 있는 것으로 합니다. 이 경우 당사는 사전에 변경 후의 이용 약관을 서비스 이용자에게 통지합니다.</span>
            <span class="text">(1) 본건 규약의 변경 내용이 서비스 이용자의 일반 이익에 적합하는 경우</span>
            <span class="text">(2) 본건 이용 규약의 변경이 서비스 이용 계약의 목적에 반하지 않고, 또한, 변경의 필요성, 변경 후의 내용의 상당성, 그 외 변경에 걸리는 사정에 비추어 합리적인 경우</span>
            <span class="text">2 당사는, 전항에 정하는 것 외, 서비스 이용자로부터 본건 이용 규약의 변경에 대해서 동의를 얻는 것으로, 본건 이용 규약을 변경할 수 있는 것으로 합니다.</span>
            <span class="text">3 이하의 각 호의 경우에는, 서비스 이용자는, 본건 이용 규약의 변경에 동의한 것으로 간주합니다.</span>
            <span class="text">(1) 당사가 변경의 1개월 이상 전에 서비스 이용자에 대하여 본건 이용 규약의 변경안 및 본건 이용 규약의 변경일을 통지하고, 본건 이용 규약의 변경일까지 서비스 이용자로부터 당사에 대하여, 서면에 의해 본건 이용 규약의 변경에 대한 반대의 의사 표시가 이루어지지 않은 경우</span>
            <span class="text">(2) 당사가 서비스 이용자에게 본건 이용 규약의 변경안 및 본건 이용 규약의 변경일을 통지하고, 또한 서비스 이용자가 해당 변경일 이후에 본건 서비스를 이용한 경우</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">제24조(재판관할)</span>
            <span class="text">본건 규약 또는 서비스 이용 계약에 관한 서비스 이용자와 당사와의 소송에 대해서는, 도쿄 지방 법원을 제1심의 전속적 합의 관할 재판소로 합니다.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">2025년 2월 28일 제정</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.terms-of-service{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: black;
  .terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .shadow-box {
        justify-content: left;
      }
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: black;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .terms-of-service {
    .scroll-container {
      .shadow-box-title-description {
        .text-container {
          span.text {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
